var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"case-rare"},[_c('TextHeader',{attrs:{"text":'Очень редкие',"level":2}}),_c('div',{staticClass:"case-rare__items"},_vm._l((_vm.items),function(item,index){return _c('div',{key:index},[_c('Item',{attrs:{"itemData":item,"noTitle":false}})],1)}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }